import * as tslib_1 from "tslib";
import { getIconClassName } from '@uifabric/styling/lib/index';
import { observer } from 'mobx-react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { Toggle } from 'office-ui-fabric-react/lib/components/Toggle';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
var styles = require('./RuleRow.scss');
var classNames = require('classnames/bind').bind(styles);
var RuleRow = /** @class */ (function (_super) {
    tslib_1.__extends(RuleRow, _super);
    function RuleRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Helper method that handles user click on toggle
         * @param event user click event
         * @param shouldBeEnabled whether rule should be enabled
         */
        _this.onEnableDisableRule = function (event, shouldBeEnabled) {
            event.stopPropagation();
            _this.props.enableDisableRule(shouldBeEnabled);
        };
        /**
         * Helper method that handles user click on delete
         * @param event user click event
         */
        _this.onRemoveRule = function (event) {
            event.stopPropagation();
            _this.props.removeRule();
        };
        /**
         * Helper method that handles user click on edit
         * @param event user click event
         */
        _this.onEditRule = function (event) {
            event.stopPropagation();
            _this.props.editRule();
        };
        /**
         * Helper method that handles user click on edit
         * @param event user click event
         */
        _this.onMoveRuleUp = function (event) {
            event.stopPropagation();
            _this.props.moveRule(true /* shouldMoveUp */);
        };
        /**
         * Helper method that handles user click on edit
         * @param event user click event
         */
        _this.onMoveRuleDown = function (event) {
            event.stopPropagation();
            _this.props.moveRule(false /* shouldMoveUp */);
        };
        return _this;
    }
    RuleRow.prototype.render = function () {
        var _this = this;
        var _a = this.props, ruleName = _a.ruleName, ruleDescription = _a.ruleDescription, isChecked = _a.isChecked, isDisabled = _a.isDisabled, editRule = _a.editRule, moveRule = _a.moveRule, alertString = _a.alertString, customClassNames = _a.customClassNames;
        var isRuleChecked = !isDisabled ? isChecked : false;
        var buttonStyles = {
            rootDisabled: styles.iconDisabled,
        };
        return (React.createElement("div", { className: classNames(styles.ruleContainer, customClassNames), tabIndex: -1 },
            React.createElement("div", { className: styles.ruleLeft },
                React.createElement(Toggle, { className: styles.ruleToggle, styles: {
                        pillChecked: styles.themeDarkBackground,
                        pillHovered: styles.themeDarkerBackground,
                    }, checked: isChecked && !isDisabled, disabled: isDisabled, offAriaLabel: strings.options_rules_disableRuleAriaText, onAriaLabel: strings.options_rules_enableRuleAriaText, title: isChecked
                        ? strings.options_rules_disableRuleToolTipText
                        : strings.options_rules_enableRuleToolTipText, onClick: function (evt) {
                        _this.onEnableDisableRule(evt, !isRuleChecked);
                    } }),
                React.createElement("div", { className: classNames(styles.ruleText, !isRuleChecked && styles.disabledRuleText), onDoubleClick: this.props.onDoubleClick },
                    React.createElement("div", { className: styles.ruleName },
                        ruleName,
                        " "),
                    ruleDescription && (React.createElement("div", { className: styles.ruleHelperText }, ruleDescription)),
                    alertString && (React.createElement("div", { className: styles.ruleAlert },
                        React.createElement("div", { className: classNames(getIconClassName("Warning" /* Warning */), styles.icon) }),
                        React.createElement("span", null, alertString))))),
            React.createElement("div", { className: styles.icons },
                this.props.runRuleNow &&
                    (this.props.isRuleRunning ? (React.createElement(Spinner, { size: SpinnerSize.small, className: styles.icon, title: strings.options_rules_runningRuleSpinnerToolTipText, "aria-label": format(strings.options_rules_runningRuleSpinnerAriaText, ruleName) })) : (React.createElement(IconButton, { iconProps: { iconName: "Play" /* Play */ }, disabled: this.props.disableRunRuleNow, onClick: this.props.runRuleNow, "aria-label": format(strings.options_rules_runRuleNowAriaText, ruleName), title: this.props.disableRunRuleNow
                            ? strings.options_rules_runRuleNowDisabledToolTipText
                            : strings.options_inboxRules_runRuleNow, styles: buttonStyles }))),
                moveRule && (React.createElement(IconButton, { iconProps: { iconName: "Up" /* Up */ }, disabled: this.props.disableUpArrow, onClick: this.onMoveRuleUp, "aria-label": format(strings.options_rules_moveRuleUpAriaText, ruleName), title: strings.options_rules_moveRuleUpToolTipText, styles: buttonStyles })),
                moveRule && (React.createElement(IconButton, { iconProps: { iconName: "Down" /* Down */ }, disabled: this.props.disableDownArrow, onClick: this.onMoveRuleDown, "aria-label": format(strings.options_rules_moveRuleDownAriaText, ruleName), title: strings.options_rules_moveRuleDownToolTipText, styles: buttonStyles })),
                editRule && (React.createElement(IconButton, { iconProps: { iconName: "Edit" /* Edit */ }, onClick: this.onEditRule, "aria-label": format(strings.options_rules_editRuleAriaText, ruleName), title: strings.options_rules_editRuleToolTipText })),
                React.createElement(IconButton, { iconProps: { iconName: "Delete" /* Delete */ }, onClick: this.onRemoveRule, "aria-label": format(strings.options_rules_deleteRuleAriaText, ruleName), title: strings.options_rules_deleteRuleToolTipText }))));
    };
    RuleRow = tslib_1.__decorate([
        observer
    ], RuleRow);
    return RuleRow;
}(React.Component));
export default RuleRow;
//# sourceMappingURL=RuleRow.js.map